import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Download, Paperclip } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { downloadBlob } from '../../utils/fileUtils';

const telechargerPiece = async (emailId, index, nom) => {
  try {
    const r = await axios.get(`/emails-envoyes/${emailId}/pieces/${index}`, { responseType: 'blob' });
    downloadBlob(r.data, nom);
  } catch { toast.error('Pièce jointe non disponible'); }
};

export const EmailEnvoyeDialog = ({ emailId, onClose }) => {
  const [mail, setMail] = useState(null);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    setMail(null); setErreur('');
    if (emailId) axios.get(`/emails-envoyes/${emailId}`).then((r) => setMail(r.data)).catch((e) => setErreur(e.response?.data?.detail || 'Contenu indisponible'));
  }, [emailId]);

  return (
    <Dialog open={!!emailId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="email-envoye-dialog">
        <DialogHeader>
          <DialogTitle data-testid="email-envoye-objet">{mail?.objet || 'E-mail envoyé'}</DialogTitle>
          {mail && (
            <DialogDescription>
              À {mail.destinataires.join(', ')} · {new Date(mail.date).toLocaleString('fr-FR')}{mail.envoye_par ? ` · par ${mail.envoye_par}` : ''}
            </DialogDescription>
          )}
        </DialogHeader>
        {erreur && <p className="text-sm text-slate-500" data-testid="email-envoye-erreur">{erreur}</p>}
        {mail && (
          <div className="space-y-3">
            <iframe title="Contenu de l'e-mail" sandbox="" srcDoc={mail.html} className="w-full h-80 rounded-lg border bg-white" data-testid="email-envoye-contenu" />
            {mail.pieces?.length > 0 && (
              <div className="space-y-1.5" data-testid="email-envoye-pieces">
                <p className="flex items-center gap-1.5 text-sm font-medium text-slate-700"><Paperclip className="h-4 w-4" /> Pièces jointes</p>
                {mail.pieces.map((p, i) => (
                  <div key={i} className="flex items-center justify-between text-sm rounded-md bg-slate-50 px-3 py-1.5">
                    <span className="truncate">{p.nom}</span>
                    {p.source && (
                      <Button size="sm" variant="ghost" onClick={() => telechargerPiece(emailId, i, p.nom)} data-testid={`email-envoye-piece-${i}`}>
                        <Download className="h-4 w-4" />
                      </Button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
